<template>
  <div>
    <!--====== PRELOADER PART START ======-->

    <!-- <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>        
        <div class="layer layer-three"><span class="overlay"></span></div>        
    </div> -->

    <!--====== PRELOADER PART ENDS ======-->

    <!--====== OFFCANVAS MENU PART START ======-->

    <sidebar-home-one :sidebar="sidebar" @toggleSidebar="toggleSidebar" :menuItems="navs"/>

    <!--====== OFFCANVAS MENU PART ENDS ======-->
   
    <!--====== APPIE HEADER PART START ======-->
    
    <header-home-one @toggleSidebar="toggleSidebar" :menuItems="navs"/>
    
    <!--====== APPIE HEADER PART ENDS ======-->

    <!--====== APPIE HEADER PART ENDS ======-->

    <div class="appie-about-top-title-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="appie-about-top-title">
                        <h2 class="title">TroFii - The Foodie App</h2>
                        <p>Food picker: picture food recommendations & photo food ratings for menu units.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--====== APPIE HEADER PART ENDS ======-->


    <!--====== APPIE HEADER PART ENDS ======-->

    <section class="appie-about-page-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="appie-about-page-content">
                        <h3 class="title">✅<b> Download and use TroFii Food Photo Menu Reviews for FREE! </b></h3>
                        <p><b>THE FIRST AND ONLY PICTURE MENU APP</b> <br> <br>
Are you looking for a food reviews app so you can find the best restaurants nearby? <br>
Do you want to view picture food menus of individual menu items from many amazing restaurants nearby? <br>

Meet <b>TroFii</b>, the first and only picture menu app where foodies and gastronomy aficionados can take photos and rate individual menu dishes that are later presented to the TrofII app.  <br>

Don’t know what to eat? Discover amazing food in this picture menu food reviews and food picker app! <br>

 <br>📸<b>  PICTURE-RATED MENU</b> <br>
Open and use TroFii as your local restaurant finder! Browse food menus by keyword or select a particular cuisine. Overview food photography menus, food offers, and ingredients of each dish. Read authentic food reviews with photos to make wise decisions. Use our dining around me app as a guide for discovering amazing tastes. <br>

 <br>🔎<b>  FIND RESTAURANTS, BARS, CAFES NEARBY</b> <br>
Discover food places and the best food nearby with our find food near me app. Whether you want fast-food restaurants, Italian restaurants, classic BBQ joints, Mexican restaurants, or vegetarian restaurants, you can discover them easily with our food finder picture menu app. 

 <br> <br>🍲<b>  WHY USE TROFII?</b> <br>
● <b>Explore the best food around:</b> Download our food picker app and easily discover the best restaurants, cafes or perhaps breakfast food drink, taco time, Chinese fast food, seafood restaurant or takeaway Chinese. Have a specific dish or food in mind? Search by keyword and find out who makes it the best.

 <br> <br>● <b>Find the best restaurants and food places:</b> View great foods menu, picture rated food menus to help you choose the ideal order, phone numbers for restaurant reservations, directions, reviews by users, and all the other information you would require choose a restaurant for taking away, dine out, or for food deliveries!

 <br> <br>● <b>Share your experience:</b> Recommend amazing dishes to others! Share the photos food ratings and reviews of restaurants you've been to. Spread good words, or warn others when you think a particular item on the menu is a big no.

 <br> <br>● <b>Earn eGifts:</b> Get $1 every time you take a picture of your food from selected restaurants and get approval from the team of TroFii. You can also get $1 egift for each referral. Every real foodie’s dream!

 <br> <br>● <b>Find transparent food reviews:</b> Get the most accurate feedback not only about the restaurant but also about individual and specific food options with the price information.

 <br> <br>● <b>Scroll through the best food around you easily:</b> Our intuitive food finder UI with a picture food menu takes the guesswork out when looking for food recommendations. 

 <br> <br>● <b>Your picture food diary:</b> Take a photo of each of your meals when dining out. Review and upload them on TroFii and have your personal food photo journal to inspire and inform fellow foodies.

Now it’s time to try the first & only picture menu app. We promise, dining out will never be the same after you try TroFii. Whether you are looking for the new amazing food that you haven’t tried, or you are looking for the best restaurants and food nearby, TroFii is your go-to app.
</p>
                        <!-- <a href="#"> View all Members <i class="fal fa-arrow-right"></i></a> -->
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!--====== APPIE HEADER PART ENDS ======-->

    <!--====== APPIE SERRVICE 2 PART START ======-->
    
    <service-aboutus/>
    
    <!--====== APPIE SERRVICE 2 PART ENDS ======-->

    <!--====== APPIE TEAM PART START ======-->
    
   <team-aboutus/>
    
    <!--====== APPIE TEAM PART ENDS ======-->

    <!--====== APPIE SPONSER PART START ======-->
    
    <sponser-home-two title="TroFii" more_title="Restaurants" description="More than 240 restaurants: "/>
    
    <!--====== APPIE SPONSER PART ENDS ======-->

    <!--====== APPIE SPONSER PART ENDS ======-->
    <get-started/>

    <!--====== APPIE SPONSER PART ENDS ======-->

    <!--====== APPIE FOOTER PART START ======-->
    
    <footer-home-one class="appie-footer-area appie-footer-about-area"/>
    
    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import FooterHomeOne from '../HomeOne/FooterHomeOne.vue'
import HeaderHomeOne from '../HomeSeven/HeaderHomeSeven.vue'
import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'
// import SponserHomeTwo from '../HomeTwo/SponserHomeTwo.vue'
// import ServiceAboutus from './ServiceAboutus.vue'
// import TeamAboutus from './TeamAboutus.vue'
export default {
	components: { SidebarHomeOne, HeaderHomeOne, FooterHomeOne },
    data(){
        return{
            sidebar:false,
            
            navs:[
            {
                name:'Home',
                path:'/'
            },
            {
                name:'About us',
                path:'/about-us'
            },
            {
                name:'Features',
                path:'/service-details'
            },
            {
                name:'Support',
                path:'/contact'
            }
            ]
        }
    },
     mounted() {
        document.addEventListener('scroll', this.topToBottom)
    },
    methods:{
        topToBottom(){
        const result = document.querySelector('.back-to-top')
           if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight ) {
                result.style.display = "block";
            } else {
                result.style.display = "none";
            }
        },
         toggleSidebar(){
           this.sidebar = !this.sidebar
        },  
    }

}
</script>

<style>

</style>